import { Button, Theme, styled } from '@material-ui/core';

export const StyledLoginButton = styled(Button)<Theme>(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(1),
  background: theme.palette.primary.dark,
  color: theme.palette.common.white,
  width: '100%',
  '&:hover': {
    background: theme.palette.primary.main,
  },
}));

export const LoginButtonLogo = styled('div')<Theme>(({ theme }) => ({
  height: '3rem',
  width: '4rem',
  paddingRight: theme.spacing(1),
  marginRight: theme.spacing(1),
  borderRight: theme.config.defaultBorder(theme.palette.common.white),
  textAlign: 'center',
  '& svg': {
    display: 'block',
    height: '100%',
    width: '100%',
  },
}));

export const LoginButtonLabel = styled('div')({
  flex: 5,
  textAlign: 'left',
});
